import { type YDatabase } from '@databases/collab/y-database';

/** This migration updates views which have `groupFieldId` set to use the new `grouping` settings format instead. */
export const groupFieldIdToGroupingSettings = {
  version: 1760551669381, // Timestamp of the migration when it's written
  apply(_documentId: string, ydb: YDatabase) {
    for (const viewId of ydb.views) {
      const view = ydb.viewsById[viewId];

      if (view && view.groupFieldId && !view.grouping) {
        const groupField = ydb.fieldsById[view.groupFieldId];

        if (groupField) {
          const grouping = view.initGrouping();
          grouping.groupByField(view.groupFieldId, []);
          view.groupFieldId = undefined;
        }
      }
    }
  },
};
